import {
  List,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { usePopupState } from 'material-ui-popup-state/hooks';
import { useState } from 'react';
import { IChatConversation } from 'src/@types/chat';
import { DocItem } from 'src/@types/docs';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useDocsActionBarUIState } from '../Docs/useDocsActionBarUIState';
import { ActionsBarButtonStyled } from '../shared/styles';
import { AddChatSelector } from './AddChatSelector';
import { AddDocSelector } from './AddDocSelector';
import { useChatActionBarUIState } from './useChatActionBarUIState';

export const AddActionBar = () => {
  const [selected, setSelected] = useState<'doc' | 'chat' | null>();

  const { translate } = useLocales();

  const { docsIDList, deleteDocFromList, addDocToList } =
    useDocsActionBarUIState();

  const { chatIDList, deleteChatFromList, addChatToList } =
    useChatActionBarUIState();

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'addToDrawerMenu',
  });

  const toggleAddDoc = (doc: DocItem) => {
    if (docsIDList.includes(doc._id)) {
      deleteDocFromList(doc._id);
      return;
    }
    addDocToList(doc._id);
  };

  const toggleAddChat = (chat: IChatConversation) => {
    if (chatIDList.includes(chat._id)) {
      deleteChatFromList(chat._id);
      return;
    }
    addChatToList(chat._id);
  };

  const handleClose = () => {
    popupState.close();
    setSelected(null);
  };

  return (
    <>
      <ActionsBarButtonStyled
        variant="outlined"
        color="inherit"
        tooltip={translate('actions_bar.add_to_drawer')}
        placement="left"
        {...bindTrigger(popupState)}
      >
        <Iconify icon="tabler:plus" />
      </ActionsBarButtonStyled>
      <Menu
        {...bindMenu(popupState)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              width: 350,
              maxHeight: 600,
              '& .MuiMenuItem-root:not(:last-child)': {
                marginBottom: 0.5,
              },
              '& .sublist': {
                padding: 0,
              },
            },
          },
        }}
      >
        {!selected && (
          <List className="sublist">
            <MenuItem onClick={() => setSelected('doc')}>
              <ListItemIcon>
                <Iconify icon="tabler:chevron-left" />
              </ListItemIcon>
              <ListItemText>
                {translate('header.nav_vertical.board_tab.docs')}
              </ListItemText>
            </MenuItem>
            <MenuItem onClick={() => setSelected('chat')}>
              <ListItemIcon>
                <Iconify icon="tabler:chevron-left" />
              </ListItemIcon>
              <ListItemText>
                {translate('header.nav_vertical.communicate.chat_channels')}
              </ListItemText>
            </MenuItem>
          </List>
        )}
        {selected === 'doc' && (
          <AddDocSelector
            backToRoot={() => setSelected(null)}
            selectDoc={toggleAddDoc}
            selectedArray={docsIDList}
          />
        )}
        {selected === 'chat' && (
          <AddChatSelector
            backToRoot={() => setSelected(null)}
            selectChat={toggleAddChat}
            selectedArray={chatIDList}
          />
        )}
      </Menu>
    </>
  );
};
